import newIo from '@/lib/io/promiseIo'
import conf, {  } from '@/lib/conf'
import io from '../lib/io'
import util from '@/lib/util'

const ucApiPath = conf.ucApiPath

const api = {
  getCurrentUserInfo: ucApiPath + '/api/customer/user/u/getCurrentUserInfo',
  bindStudent: ucApiPath + '/api/customer/user/u/bindStudent',
  myBindStudents: ucApiPath + '/api/customer/user/u/myBindStudents',
  unbindStudent: ucApiPath + '/api/customer/user/u/unbindStudent',
  updateStudent: ucApiPath + '/api/customer/user/u/updateStudent',
  updateCurrentUserInfo: ucApiPath + '/api/customer/user/u/updateCurrentUserInfo',
  changePhoneNo: ucApiPath + '/api/customer/user/u/changePhoneNo',
  sendPhoneCode: ucApiPath + '/api/customer/user/sendPhoneCode',
  getStudent: ucApiPath + '/api/customer/user/u/getStudent',
  bindPhoneNo: ucApiPath + '/api/customer/user/wx/bindPhoneNo',
  autoBindStudent: ucApiPath + '/api/customer/user/u/autoBindStudent',
}

export function gradeAndSubjectList(){
  return newIo.post(`${io.gradeAndSubjectList}`)
}

export function campusOfAreaTeam(params){
  return newIo.post(`${io.campusOfAreaTeam}?areaTeamId=${params}`, )
}

export function testSubscribe(params){
  return newIo.postPlayload(io.testSubscribe,params)
}

export function getCurrentUserInfo(params){
  return newIo.postPlayload(api.getCurrentUserInfo, params)
}

export function bindStudent(params){
  return newIo.postPlayload(api.bindStudent, params)
}

export function myBindStudents(params){
  return newIo.postPlayload(api.myBindStudents, params)
}

export function unbindStudent(studentId){
  return newIo.postPlayload(`${api.unbindStudent}?studentId=${studentId}`)
}

export function updateStudent(query){
  return newIo.postPlayload(`${api.updateStudent}?${util.getObjToQuery(query)}`)
}

export function updateCurrentUserInfo(params){
  return newIo.postPlayload(api.updateCurrentUserInfo, params)
}

export function changePhoneNo(query){
  return newIo.postPlayload(api.changePhoneNo + `?${util.getObjToQuery(query)}`, )
}

export function sendPhoneCode(query){
  return newIo.postPlayload(api.sendPhoneCode + `?${util.getObjToQuery(query)}`, )
}

export function getStudent(query){
  return newIo.postPlayload(api.getStudent + `?${util.getObjToQuery(query)}`, )
}

export function bindPhoneNo(query){
  return newIo.postPlayload(api.bindPhoneNo + `?${util.getObjToQuery(query)}`, )
}

export function autoBindStudent(query){
  return newIo.postPlayload(api.autoBindStudent + `?${util.getObjToQuery(query)}`, )
}



// WEBPACK FOOTER //
// ./src/api/mine.js